'use client';

import {
  alpha,
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
} from '@mui/material';

export const ProfileActivitySkeleton = () => {
  const theme = useTheme();

  return (
    <TableContainer sx={{ mt: 2 }}>
      <Table sx={{ minWidth: 650 }}>
        <TableBody>
          {[...Array(5)].map((_, i) => (
            <TableRow key={i}>
              <TableCell
                colSpan={3}
                sx={{
                  py: 3,
                  borderBottom: '1px solid',
                  borderColor: alpha(theme.palette.text.primary, 0.05),
                }}
              >
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <Skeleton
                    variant="rectangular"
                    width={48}
                    height={48}
                    sx={{ borderRadius: 1.5, bgcolor: alpha(theme.palette.text.primary, 0.05) }}
                  />
                  <Box sx={{ flex: 1 }}>
                    <Skeleton
                      variant="text"
                      width="40%"
                      height={24}
                      sx={{ bgcolor: alpha(theme.palette.text.primary, 0.05), mb: 0.5 }}
                    />
                    <Skeleton
                      variant="text"
                      width="20%"
                      height={18}
                      sx={{ bgcolor: alpha(theme.palette.text.primary, 0.05) }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                      gap: 0.5,
                    }}
                  >
                    <Skeleton
                      variant="text"
                      width={80}
                      height={24}
                      sx={{ bgcolor: alpha(theme.palette.text.primary, 0.05) }}
                    />
                    <Skeleton
                      variant="text"
                      width={60}
                      height={18}
                      sx={{ bgcolor: alpha(theme.palette.text.primary, 0.05) }}
                    />
                  </Box>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
